import { MutationTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertyRelationTypesStore from "./property-relation-types.store";
import { IPropertyRelationModel } from "../../../../models/property";
import { itemStateConstant } from "../../../../common";


const relationMutations: MutationTree<IPropertyEditState> = <MutationTree<IPropertyEditState>>{
	/**
	 * HANDLE GET LIST
	 */
	[propertyRelationTypesStore.Set.LIST_OF_PROPERTY_RELATIONS]: (
		state: IPropertyEditState,
		listOfPropertyRelations: IPropertyRelationModel[]
	) => {
		state.property.Relations = listOfPropertyRelations;
	},

	/** HANDLE UPDATE VALUE FOR FIELD */
	/**
	 * UPDATED
	 */
	[propertyRelationTypesStore.Set.ASSIGNVALUE_RELATION]: (
		state: IPropertyEditState,
        updateModel: IPropertyRelationModel
    ) => {
        const keys = Object.keys(updateModel);
        keys.forEach(key => {
            var entity = state.property.Relations.find(c => c.Id == updateModel.Id);
            if (entity != undefined) {
                // keep old relation type id
                let oldRelationType = entity.RelationTypeId;
                let oldPersonIndex = entity.PersonIndex;

                // update value
                if (key == "PersonIndex") {
                    const replacePersonNumberItem = state.property.Relations.find(c =>
                        c.RelationTypeId === entity.RelationTypeId && c.PersonIndex == updateModel[key] as any);
                    replacePersonNumberItem.PersonIndex = oldPersonIndex;
                    entity.PersonIndex = updateModel[key] as any;

                    if (entity.ItemState != itemStateConstant.Added) {
                        entity.ItemState = itemStateConstant.Modified;
                    }

                    if (replacePersonNumberItem.ItemState != itemStateConstant.Added) {
                        replacePersonNumberItem.ItemState = itemStateConstant.Modified;
                    }
                } else {
                    entity[key] = updateModel[key];
                    if (entity.ItemState != itemStateConstant.Added)
                        entity.ItemState = itemStateConstant.Modified;

                    if (key == "RelationTypeId") {
                        // UPDATE INDEX BY NEW RELATION TYPE
                        let maxIndex = 0;
                        let sameRelationTypeItems = state.property.Relations.filter(
                            x => x.RelationTypeId == entity.RelationTypeId && x.Id != entity.Id
                        );
                        if (sameRelationTypeItems.length > 0) {
                            maxIndex = Math.max.apply(
                                Math,
                                sameRelationTypeItems.map(function (o) {
                                    return o.PersonIndex;
                                })
                            );
                        }
                        entity.PersonIndex = maxIndex + 1;

                        // UPDATE INDEX BY OLD RELATION TYPE
                        let items = state.property.Relations.filter(
                            x =>
                                x.RelationTypeId == oldRelationType &&
                                x.PersonIndex > oldPersonIndex
                        ).sort(c => c.PersonIndex);
                        if (items == null || items.length == 0) return;
                        items.forEach(element => {
                            element.PersonIndex = oldPersonIndex;
                            if (element.ItemState != itemStateConstant.Added)
                                element.ItemState = itemStateConstant.Modified;
                            oldPersonIndex = oldPersonIndex + 1;
                        });
                    }
                }
            }
        });
	},

	/** HANDLE ADD NEW RELATION */
	[propertyRelationTypesStore.Set.ADD_TO_LIST]: (
		state: IPropertyEditState,
		relation: IPropertyRelationModel
	) => {
		// get min id
		let minId = -1;
		if (state.property.Relations.length > 0) {
			let addedItems = state.property.Relations.filter(
				x => x.ItemState === itemStateConstant.Added
			);
			if (addedItems.length > 0) {
				minId = Math.min.apply(
					Math,
					addedItems.map(function (o) {
						return o.Id;
					})
				);
			}
		}

		// add item to list
		minId = minId - 1;
		relation.ItemState = itemStateConstant.Added;
		relation.Id = minId;
		state.property.Relations.push(relation);
	},

	/** HANDLE ADD NEW RELATION */
	[propertyRelationTypesStore.Set.DELETE_RELATION]: (
		state: IPropertyEditState,
		id: number
	) => {
		// UPDATE ITEM IF THIS IS ITEM HAD BE STORED IN THE SERVICE
		// DELETE ITEM IF THIS IS ITEM HAD JUST ADDED
		let item = state.property.Relations.find(x => x.Id === id);
		if (item == null) return;
		let personIndex = item.PersonIndex;
		if (item.ItemState === itemStateConstant.Added) {
			let index = state.property.Relations.indexOf(item);
			state.property.Relations.splice(index, 1);
		} else {
			item.ItemState = itemStateConstant.Deleted;
		}

		// UPDATE INDEX FOR OTHER RELATION BY RELATION TYPE
		let items = state.property.Relations.filter(
			x =>
				x.RelationTypeId == item.RelationTypeId && x.PersonIndex > personIndex
		).sort(c => c.PersonIndex);
		if (items == null || items.length == 0) return;
		items.forEach(element => {
			element.PersonIndex = personIndex;
			if (element.ItemState != itemStateConstant.Added && element.ItemState != itemStateConstant.Deleted)
				element.ItemState = itemStateConstant.Modified;
			personIndex = personIndex + 1;
		});
	}
};

export default relationMutations;
